import styled, { css } from 'styled-components';

export const PanelWrapper = styled.section`
  display: flex;
  min-height: 100%;
  flex-direction: column;
`;

export const ViewSection = styled.section`
  margin: 0;
  color: ${({ theme }) => theme.colors.black_9};
  font-size: 14px;
  padding: 0 20px;
  margin-bottom: 40px;

  @media ${({ theme }) => theme.sizes.tablet} {
    padding: 0px 42px;
  }

  .ql-editor {
    p {
      margin: 0 0 15px;
    }
  }
`;

export const LockInfo = styled.div`
  align-self: flex-end;
  background-image: url(/assets/images/theme-2/icons/locked_black.svg);
  background-position: left 1px;
  background-repeat: no-repeat;
  background-size: 16px;
  opacity: 0.8;
  padding-left: 25px;
`;

export const HeaderUserImage = styled.div`
  height: 30px;
  width: 30px;
  background-size: cover;
  display: flex;
  flex-shrink: 0;
  margin-right: 10px;
  background-position: 50%;
  border-radius: 50%;

  ${({ src }) =>
    src &&
    css`
      background-image: url(${src});
    `}
`;

export const HeaderUserName = styled.div``;

export const HeaderDate = styled.div`
  margin-left: 20px;
`;

export const HeaderRequestFeedback = styled.button`
  background-color: ${({ theme }) => theme.colors.transparent};
  outline: none;
  border: none;
  cursor: pointer;
  height: 22px;
  width: 22px;
  margin-left: 10px;
  opacity: 0.7;
  transition: opacity 0.2s ease;

  @media ${({ theme }) => theme.sizes.tablet} {
    margin-left: 20px;
  }

  &:hover:not(&:disabled),
  &:focus:not(&:disabled) {
    opacity: 1;
    transition: opacity 0.2s ease;
  }

  ${({ src }) =>
    src &&
    css`
      background-image: url(${src});
    `}

  ${({ isEditable }) =>
    !isEditable &&
    css`
      background-color: ${({ theme }) => theme.colors.black};
      background-position: 50%;
      background-size: 12px;
      background-repeat: no-repeat;
      border-radius: 50%;
    `}
`;

export const AutoSaveStatus = styled.div`
  color: ${({ theme }) => theme.colors.black_6};
  margin-right: 10px;
  height: 20px;
`;

export const ToolbarWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const ToolbarButton = styled.button`
  background-image: url(/assets/images/theme-2/icons/show-toolbar.svg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  outline: none;
  border: none;
  background-color: ${({ theme }) => theme.colors.transparent};
  width: 20px;
  height: 20px;
  cursor: pointer;
  display: flex;
  margin-left: 10px;
  flex-shrink: 0;
  opacity: 0.7;
  transition: opacity 0.2s ease;

  &:hover:not(&:disabled),
  &:focus:not(&:disabled) {
    opacity: 1;
    transition: opacity 0.2s ease;
  }

  &.show {
    background-image: url(/assets/images/theme-2/icons/hide-toolbar.svg);
  }

  &.attachment {
    background-image: url(/assets/images/theme-2/icons/text-editor/plus-_attach-file.svg);
  }

  &.video {
    background-image: url(/assets/images/theme-2/icons/text-editor/plus-_record-movie.svg);
  }

  &.audio {
    background-image: url(/assets/images/theme-2/icons/text-editor/plus-_reccord-sound.svg);
  }

  &.immersiveReader {
    background-image: url(/assets/images/theme-2/icons/panel-header/immersive-reader.svg);
  }
`;

export const ColumnWrapper = styled.div`
  display: flex;
  min-height: 100%;
  flex-direction: column;
`;

export const ButtonWrapper = styled.div`
  align-items: center;
  display: flex;
  font-size: 14px;
  justify-content: flex-end;
  margin: 15px 0;

  button {
    border: 2px solid ${({ theme }) => theme.colors.buttonGreenFront};
    font-weight: bold;

    &:hover:not([disabled]),
    &:focus:not([disabled]) {
      border-color: ${({ theme }) => theme.colors.black};
    }
  }
`;

export const PublishWrapper = styled.div`
  display: flex;

  > div {
    margin-right: 10px;
  }

  .publish[disabled] {
    background-color: ${({ theme }) => theme.colors.hoverGrey};
    border-color: ${({ theme }) => theme.colors.transparent};
    cursor: default;
    opacity: 0.7;
  }
`;

export const ButtonPanel = styled.div`
  display: flex;

  .publish[disabled] {
    background-color: ${({ theme }) => theme.colors.hoverGrey};
    border-color: ${({ theme }) => theme.colors.transparent};
    cursor: default;
    opacity: 0.7;
  }
`;

export const QuestionWrapper = styled.div``;
